import { CgArrowLongRight } from "react-icons/cg";
import Features from "../Features/Features";
import mockup from "../../Assets/Mockups/mockup1.png";
import invoices_mockup from "../../Assets/Mockups/invoices_mockup.svg";
import payment_mockup from "../../Assets/Mockups/payment_mockup.svg";
import Courasel from "../Courasel/Courasel";
import Choices from "./Choices";
import { useState } from "react";
import { Link } from "react-router-dom";
import { lipana_signup } from "../../Config/redirect_url";

const Users = () => {
  const services = [
    {
      name: "Invoices",
      image: invoices_mockup,
      link: "explore invoices",
      text: "Make payments easier for your customers with online invoices they can pay with their MPESA, Card or Crypto payments.",
    },
    {
      name: "Payment links",
      image: payment_mockup,
      link: "",
      text: "Start accepting payments, subscriptions and donations through your dedicated and custom payment link.",
    },
    {
      name: "Payouts",
      image: mockup,
      link: "",
      text: "Disburse payments to vendors, part-time staff or service providers, through instant file uploads or easily integrated APIs.",
    },
  ];

  const [index, setCurrentIndex] = useState(0);
  const getCurrentIndex = (num) => {
    setCurrentIndex(num);
  };

  return (
    <section className="px-5 xl:px-0 mt-32 text-blackColor">
      <div className="mx-auto max-w-6xl h-full">
        <div>
          <Features />
        </div>
        <div className="!mt-8 md:mt-32">
          <Choices />
        </div>
        <div className="flex flex-col items-center bg-white py-8 px-5 mt-8 rounded-[20px] shadow-[0px 4px 4px rgba(0, 0, 0, 0.1)] md:gap-20 md:rounded-[40px] md:flex-row md:mt-32 md:px-8 md:py-16 lg:gap-0 lg:px-20">
          {/* For Desktop */}
          <div className="hidden space-y-16 w-1/2 md:block">
            <div className="space-y-3 md:space-y-8">
              {services.map((service, i) => (
                <div
                  key={i}
                  className={`${
                    index === services.indexOf(service)
                      ? `bg-gray-100 text-blackColor text-lg rounded-r-full`
                      : `text-gray-500  text-base`
                  } cursor-pointer py-3 px-5 rounded font-semibold lg:w-1/2`}
                >
                  <h3 className="text-2xl">{service.name}</h3>
                </div>
              ))}
            </div>
            <div className="flex gap-10 flex-col w-full lg:flex-row">
              <Link to={lipana_signup()}>
                <button className="mt-5 border bg-brandColor font-semibold text-white py-3 md:px-10 rounded-full text-[14px]">
                  Create a Free Account
                </button>
              </Link>

              <Link to={"contact"}>
                <button className="mt-5 bg-[#E6F0FF] font-semibold text-brandColor py-3 md:px-10 rounded-full text-[14px]">
                  Contact Sales
                </button>
              </Link>
            </div>
          </div>

          {/* For Mobile */}
          <div className="mb-8 flex flex-row justify-between items-center w-full md:hidden">
            {services.map((service, i) => (
              <div
                key={i}
                className={`${
                  index === services.indexOf(service)
                    ? `text-blackColor rounded text-[16px]`
                    : `text-gray-500 text-[12px]`
                } cursor-pointer py-2 px-2 rounded-lg font-semibold`}
              >
                <h3>{service.name}</h3>
              </div>
            ))}
          </div>

          <div className="text-center space-y-5 md:mt-0 mb-3 md:mb-0 md:w-1/2">
            <div className="">
              <Courasel
                direction="X"
                flex="row"
                duration="0"
                delay={5000}
                arrows="hidden"
                getIndex={getCurrentIndex}
              >
                {services.map((service, i) => (
                  <div className="min-w-full space-y-8" key={i}>
                    <img
                      src={service.image}
                      alt="mockup"
                      className="h-56 object-contain w-max mx-auto md:h-64 lg:h-96"
                    />
                    <p>{service.text} </p>
                    <p className="mt-3"></p>
                    <Link to={lipana_signup()}>
                      <span className="text-brandColor font-semibold flex flex-row items-center justify-center gap-1 hover:gap-3 hover:underline duration-500 cursor-pointer">
                        Explore {service.name.toLowerCase()}{" "}
                        <CgArrowLongRight className="text-2xl" />
                      </span>
                    </Link>
                  </div>
                ))}
              </Courasel>
            </div>
            <div className="flex flex-col gap-1 md:hidden">
              <Link to={lipana_signup()}>
                <button className="mt-5 border bg-brandColor font-semibold text-white py-3 rounded-full w-full">
                  Create a Free Account
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Users;
